/*
 * @Author: luting
 * @Date: 2022-04-19 15:27:45
 * @lastEditors: luting
 * @LastEditTime: 2023-02-07 09:50:55
 */
import React, { useState, useEffect } from 'react';
import { Button, Spin } from 'sup-ui';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { disk } from 'root/store/disk/actions';
import { availableDiskType } from 'root/pages/DiskConfig/diskTypes';

import messages from '../messages';

import ConfirmDiskBody from 'root/pages/DiskConfig/ConfirmDiskBody';

import CommonModal from 'root/components/CommonModal';

import styles from './index.less';

interface IChangeDisk {
  type: string;
  okText: string;
  onOk: any; // 外部传入的事件必须时Promise
  lessen?: boolean;
}

/*
调整磁盘与扩展分区的Modal
*/

const ChangeDisk: React.FC<IChangeDisk> = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { record, visible } = useSelector((state: reducerStates) => state.disk);
  const { okText, onOk, lessen = true } = props;
  const [readOnly, setReadOnly] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [showTip, setShowTip] = useState(false);
  const [minLimt, setMinLimt] = useState(false);

  useEffect(() => {
    // 当打开modal是将可编辑打开
    setReadOnly(visible);
  }, [visible]);

  const onCancel = () => {
    // 将modal关闭,选择的id为0,选择项为kong
    onCloseEvent();
    setReadOnly(false);
    setShowTip(false);
  };

  const onCloseEvent = () => {
    dispatch(disk.getVisible({ visible: false }));
    setTimeout(() => {
      // 需要将id与record延后执行,否则会出现内容先为kong,在关闭modal
      dispatch(disk.getDiskId({ id: 0 }));
      dispatch(disk.filterRecord({ id: 0 }));
    }, 800);
  };

  const clickBtnEvent = () => {
    setSubmit(true);
    onOk()
      .then(() => {
        onCloseEvent();
        setReadOnly(false);
      })
      .finally(() => {
        setSubmit(false);
      });
  };

  return (
    <CommonModal
      title={intl.formatMessage(messages.changeDiskSet)}
      visible={visible}
      onCancel={onCancel}
      width={800}
      height="auto"
      closable={false}
      footer={[
        <Button type="primary" key="ok" onClick={clickBtnEvent} disabled={submit || showTip || minLimt}>
          {okText}
        </Button>,
        <Button disabled={submit} onClick={onCancel} key="cancel">
          {intl.formatMessage(messages.cancel)}
        </Button>,
      ]}
      destroyOnClose
    >
      <Spin tip={intl.formatMessage(messages.doing)} spinning={submit}>
        {record && (
          <ConfirmDiskBody
            id={record?.id as number}
            vgName={record?.vgName as string}
            freeSize={record?.freeSize as string}
            totalSize={record?.totalSize as number}
            vgPath={record?.vgPath as string}
            dataSource={record?.mountPoints as availableDiskType[]}
            columnLists={['mountPoint', 'size']}
            updataDiskSize={readOnly}
            setShowTip={setShowTip}
            setMinLimt={setMinLimt}
            lessen={lessen}
          />
        )}
        {/* 除了全新安装以外的其余三种情况都不允许缩小磁盘容量 */}
        {!lessen && showTip && <span className={styles.lessenTip}>{intl.formatMessage(messages.cannotLessen)}</span>}
      </Spin>
    </CommonModal>
  );
};

export default ChangeDisk;
